/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_How_2_DescInputs */

const en_mk_how_2_desc = /** @type {(inputs: Mk_How_2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose the divisions your team uses; their channels and skill-pack agents get installed automatically.`)
};

const id_mk_how_2_desc = /** @type {(inputs: Mk_How_2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pilih divisi yang dipakai timmu; channel dan agen skill pack-nya otomatis terpasang.`)
};

/**
* | output |
* | --- |
* | "Choose the divisions your team uses; their channels and skill-pack agents get installed automatically." |
*
* @param {Mk_How_2_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_how_2_desc = /** @type {((inputs?: Mk_How_2_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_How_2_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_how_2_desc(inputs)
	return en_mk_how_2_desc(inputs)
});